var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 26,
    viewBox: "0 0 39 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7731 3.52504H14.2274V22.4761H24.7731V3.52504Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.897 13.0006C14.8954 11.1754 15.3089 9.37385 16.1065 7.7322C16.904 6.09054 18.0646 4.65185 19.5003 3.52503C17.7223 2.12751 15.5871 1.25841 13.3385 1.01708C11.09 0.775738 8.81887 1.17189 6.78483 2.16026C4.75079 3.14864 3.03585 4.68936 1.83605 6.60631C0.636254 8.52326 0 10.7391 0 13.0006C0 15.262 0.636254 17.4779 1.83605 19.3948C3.03585 21.3118 4.75079 22.8525 6.78483 23.8409C8.81887 24.8292 11.09 25.2254 13.3385 24.984C15.5871 24.7427 17.7223 23.8736 19.5003 22.4761C18.0646 21.3493 16.904 19.9106 16.1065 18.2689C15.309 16.6273 14.8954 14.8257 14.897 13.0006Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13.0006C39.0001 15.262 38.3639 17.4778 37.1642 19.3948C35.9644 21.3117 34.2495 22.8524 32.2155 23.8408C30.1816 24.8292 27.9105 25.2254 25.662 24.984C23.4135 24.7427 21.2782 23.8736 19.5003 22.4761C20.9348 21.3481 22.0944 19.9092 22.8918 18.2678C23.6892 16.6264 24.1035 14.8254 24.1035 13.0006C24.1035 11.1757 23.6892 9.3747 22.8918 7.73331C22.0944 6.09191 20.9348 4.65299 19.5003 3.52503C21.2782 2.12751 23.4135 1.25841 25.662 1.01707C27.9105 0.775738 30.1816 1.1719 32.2155 2.16029C34.2495 3.14868 35.9644 4.6894 37.1642 6.60635C38.3639 8.5233 39.0001 10.7391 39 13.0006Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8502 20.4689V20.0809H38.0066V20.0018H37.6082V20.0809H37.7647V20.4689H37.8502ZM38.6237 20.4689V20.0011H38.5015L38.3611 20.3228L38.2206 20.0011H38.0984V20.4689H38.1846V20.116L38.3163 20.4202H38.4058L38.5375 20.1152V20.4689H38.6237Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/mastercard-icon.7af5bc47d7ddece70d56d0bbf9e8b535.svg";
export { ForwardRef as ReactComponent };